import { useParams } from 'react-router-dom';

import { useGetRoundsQuery } from '../api';
import { formatRoundsTimelineData } from '../services/rounds';

const useGetRounds = () => {
  const { companyId } = useParams();

  const { data } = useGetRoundsQuery({
    company_id: companyId || ''
  });

  return {
    roundsTimelineData: data ? formatRoundsTimelineData(data) : [],
    data
  };
};

export default useGetRounds;
